"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TwentyFiveYearsAcademicLegacy() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="120817" id="dt-ayşegül-inneci-uzun" className="py-20 md:py-32 bg-background relative overflow-hidden text-foreground">
      {}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,var(--color-border)_1px,transparent_1px),linear-gradient(to_bottom,var(--color-border)_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_80%_50%_at_50%_0%,#000_40%,transparent_100%)] opacity-20 pointer-events-none"></div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div ref={ref} className={`grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {}
          <div className="lg:col-span-5 relative order-2 lg:order-1">
            {}
            <div className="absolute -bottom-8 -left-8 w-32 h-32 bg-secondary rounded-sm -z-10 opacity-70"></div>
            <div className="absolute -top-8 -right-8 w-40 h-40 bg-primary/10 rounded-full -z-10 blur-3xl"></div>
            
            <div className="relative rounded-sm overflow-hidden shadow-2xl border-4 border-background bg-muted">
              <img src="https://dtaysegul.10web.cloud/wp-content/uploads/2026/04/IMG_5154-1-scaled.jpg" alt="Dt. Ayşegül İnneci Uzun - Estetik Diş Hekimi" className="w-full h-auto object-cover aspect-[4/5]" />
              {}
              <div className="absolute inset-0 bg-gradient-to-t from-primary/20 via-transparent to-transparent mix-blend-multiply"></div>
            </div>
          </div>

          {}
          <div className="lg:col-span-7 flex flex-col gap-8 order-1 lg:order-2">
            <div>
              <span className="inline-block py-1 px-5 rounded-sm bg-secondary text-primary text-xs font-bold tracking-[0.2em] uppercase mb-6 shadow-sm border border-primary/10">
                Hekimimiz
              </span>
              <h2 className="text-5xl md:text-6xl lg:text-7xl font-serif font-light text-foreground tracking-tight mb-8 leading-tight">
                Dt. Ayşegül <br className="hidden md:block" />
                <span className="text-primary italic">İnneci Uzun</span>
              </h2>
              
              {}
              <div className="p-6 md:p-10 bg-secondary/30 border-l-2 border-primary rounded-sm mb-8 shadow-sm backdrop-blur-sm">
                <p className="text-2xl md:text-3xl font-serif italic text-primary leading-tight">
                  Butik Bakım ve <br className="hidden sm:block" />
                  <span className="text-5xl md:text-7xl tracking-tighter mt-2 inline-block font-sans not-italic font-light">8+</span> Yıllık Uzmanlık
                </p>
              </div>
            </div>

            <div className="space-y-6 text-lg md:text-xl text-muted-foreground leading-relaxed font-light">
              <p>Modern diş hekimliğini kişiye özel butik bir yaklaşımla harmanlayarak, hastalarımıza sadece bir tedavi değil, bir "lüks konfor" deneyimi sunuyoruz. Her gülüşün kendine has bir hikayesi olduğuna inanıyor; bu hikayeyi estetik ve doğal formunda yeniden inşa ediyoruz.</p>
              <p>
                Kayseri'deki kliniğimizde, ileri dijital teknolojileri sanatsal bir vizyonla birleştiriyoruz. Amacımız sadece fonksiyonel çözümler üretmek değil; hastalarımızın özgüvenini tazeleyecek, yaşam kalitelerini artıracak kusursuz ve sağlıklı gülüş tasarımlarına imza atmaktır.
              </p>
            </div>

            {}
            <div className="mt-6 pt-8 border-t border-border flex items-center justify-between">
              <div>
                <p className="font-serif text-3xl md:text-4xl text-foreground italic tracking-wide">
                  Diş Hekimi
                </p>
                <p className="text-xs md:text-sm text-primary mt-2 uppercase tracking-[0.3em] font-semibold">
                  Gülüş Tasarımı & Estetik Uzmanı
                </p>
              </div>
              {}
              <div className="text-primary/20 font-serif italic text-2xl md:text-3xl select-none hidden sm:block" aria-hidden="true">
                Art of the Smile
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}